import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {axiosInstance} from '../services/Api';

// Initial state for the slice
const initialState = {
  mouvementTypes: [],
  selectedMouvement:null,
  loading: false,  // Loading state as a boolean
  message: '',     // Message to store error or success message
};

// Define the fetchMouvementType async thunk to fetch data from an API
export const fetchMouvementType = createAsyncThunk(
    'mouvementTypes/fetchMouvementType', 
    async (_, { rejectWithValue }) => {
      try {
        const response = await axiosInstance.get('/stock-movement-types');  // Make GET request using the Axios instance
  
        if (response.status !== 200) {  // Check for a successful response
          throw new Error('Failed to fetch mouvement types');
        }
  
        return response.data;  // Return the data from the response
      } catch (error) {
        // Use rejectWithValue to return custom error message
        return rejectWithValue(error.response?.data?.message || error.message);
      }
    }
  );
  
  export const fetchMouvementTypeById = createAsyncThunk(
    'mouvementTypes/fetchMouvementTypeById',
    async (id, { rejectWithValue }) => {
      try {
        const response = await axiosInstance.get(`/stock-movement-types/getMouvementTypeById/${id}`);
  
        if (response.status !== 200) {
          throw new Error('Failed to fetch mouvement type');
        }
  
        return response.data;
      } catch (error) {
        return rejectWithValue(error.response?.data?.message || error.message);
      }
    }
  );
  

// Create the slice
const mouvementTypesSlice = createSlice({
  name: 'mouvementTypes',
  initialState,
  reducers: {
    setselectedMouvement: (state, action) => {
      state.selectedMouvement = action.payload;
    },
    clearselectedMouvement: (state) => {
      state.selectedMouvement = null;
    },

  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMouvementType.pending, (state) => {
        state.loading = true;  // Set loading to true while fetching
        state.message = '';    // Clear any previous messages
      })
      .addCase(fetchMouvementType.fulfilled, (state, action) => {
        state.loading = false;  // Set loading to false once fetching is complete
        state.mouvementTypes = action.payload;
        state.message = 'Mouvement Types loaded successfully'; // Success message
      })
      .addCase(fetchMouvementType.rejected, (state, action) => {
        state.loading = false;  // Set loading to false if the request fails
        state.message = action.payload || 'An error occurred while fetching mouvement types';  // Error message
      })
      .addCase(fetchMouvementTypeById.pending, (state) => {
        state.loading = true;
        state.message = '';
      })
      .addCase(fetchMouvementTypeById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedMouvement = action.payload;
        state.message = 'Mouvement Type loaded successfully';
      })
      .addCase(fetchMouvementTypeById.rejected, (state, action) => {
        state.loading = false;
        state.message = action.payload || 'An error occurred while fetching the mouvement type';
      });;
  },
});


export const {setselectedMouvement,clearselectedMouvement}=mouvementTypesSlice.actions
export default mouvementTypesSlice.reducer;
